var LayoutJustify;
(function (LayoutJustify) {
    LayoutJustify["CENTER"] = "center";
    LayoutJustify["END"] = "flex-end";
    LayoutJustify["INITIAL"] = "initial";
    LayoutJustify["NONE"] = "";
    LayoutJustify["SPACEAROUND"] = "space-around";
    LayoutJustify["SPACEBETWEEN"] = "space-between";
    LayoutJustify["SPACEEVENLY"] = "space-evenly";
    LayoutJustify["START"] = "flex-start";
    LayoutJustify["STRETCH"] = "stretch";
})(LayoutJustify || (LayoutJustify = {}));
export default LayoutJustify;
//# sourceMappingURL=layout-justify.js.map